import { ShoppingCart } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

interface CartIndicatorProps {
  itemCount: number;
}

export default function CartIndicator({ itemCount }: CartIndicatorProps) {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate('/cart');
  };

  return (
    <button
      onClick={handleClick}
      className="relative p-2 rounded-md hover:bg-neutral-100 transition-colors duration-fast"
      aria-label={`Shopping cart with ${itemCount} items`}
    >
      <ShoppingCart className="h-6 w-6 text-neutral-900" />
      {itemCount > 0 && (
        <span className="absolute -top-1 -right-1 bg-brand-primary text-white text-xs font-semibold rounded-full h-5 w-5 flex items-center justify-center">
          {itemCount > 99 ? '99+' : itemCount}
        </span>
      )}
    </button>
  );
}
